import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { useInView } from "react-hook-inview"
import "./flip-text-v2.scss"

const FlipTextV2 = ({ text }) => {
  const [ref, inView] = useInView({ threshold: 0.65, unobserveOnEnter: false })
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAnimating, setIsAnimating] = useState(false) // Start with no animation
  const [hasAnimated, setHasAnimated] = useState(false) // Track if we've done the initial animation

  // Handle initial animation when component comes into view
  useEffect(() => {
    if (text.length <= 1 || hasAnimated || !inView) return

    console.log("Starting initial animation")
    setIsAnimating(true)
    const timer = setTimeout(() => {
      console.log("Animation complete, starting rotation")
      setIsAnimating(false)
      setHasAnimated(true)
    }, 600)

    return () => clearTimeout(timer)
  }, [text.length, inView, hasAnimated])

  // Handle text rotation - separate effect
  useEffect(() => {
    if (text.length <= 1 || !inView || !hasAnimated) return

    console.log("Setting up text rotation interval")
    const interval = setInterval(() => {
      console.log("Rotating text")
      setCurrentIndex(prevIndex => (prevIndex + 1) % text.length)
    }, 3000)

    return () => clearInterval(interval)
  }, [text.length, inView, hasAnimated])

  return (
    <span className="flip-text-v2" ref={ref}>
      <span
        className={`flip-text-content ${isAnimating ? "flip-animation" : ""}`}
      >
        {text[currentIndex]}
      </span>
    </span>
  )
}

FlipTextV2.propTypes = {
  text: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default FlipTextV2
